import { Collapse } from 'bootstrap'
import ScrollBarHelper from 'bootstrap/js/src/util/scrollbar'
import Lottie from 'lottie-web/player/js/modules/svg_light'
import path from 'path'

const $navigation = document.getElementById('navigation')
const $search = document.getElementById('search')
const $logo = document.getElementById('logo')

// Hide scrollbar when navigation or search are open
if ($navigation || $search) {
	const scrollBar = new ScrollBarHelper()
	scrollBar._element = document.documentElement
	const elements = [$navigation, $search].filter(Boolean)

	let scrollBarHidden = false

	elements.forEach($element => {
		$element.addEventListener('show.bs.collapse', ({ target }) => {
			if (!scrollBarHidden && target === $element) {
				scrollBar.hide()
				scrollBarHidden = true
			}
		})
		$element.addEventListener('hidden.bs.collapse', ({ target }) => {
			if (scrollBarHidden && target === $element) {
				scrollBar.reset()
				scrollBarHidden = false
			}
		})
	})
}

// Hide navigation when clicking internal links
if ($navigation) {
	$navigation.addEventListener('click', event => {
		if (event.target.href) {
			const url = new URL(event.target.href)
			if (url.hash && window.location.pathname === url.pathname) {
				Collapse.getInstance($navigation).hide()
			}
		}
	})
}

// Logo animation
if ($logo) {
	const $logoImg = $logo.querySelector('img')

	if ($logoImg) {
		const $logoWrap = document.createElement('div')
		$logoWrap.style.display = 'contents'
		$logoWrap.style.contain = 'layout paint';
		$logoWrap.style.pointerEvents = 'none';

		const dirname = path.dirname(new URL($logoImg.src).pathname)
		const animation = Lottie.loadAnimation({
			container: $logoWrap,
			renderer: 'svg',
			loop: false,
			autoplay: true,
			path: dirname + '/logo.json',
		})

		animation.addEventListener('DOMLoaded', () => {
			$logo.replaceChild($logoWrap, $logoImg)
		})

		window.addEventListener('scroll', () => {
			if (animation.isPaused) {
				animation.goToAndPlay(0)
			}
		}, { passive: true })
	}
}
